import ReactYoutube from "react-youtube";

import { type CustomYouTubeProps } from "./YouTube";

export function YouTubeClientComponent(props: CustomYouTubeProps) {
  const opts = {
    height: props.height,
    width: props.width,
    playerVars: {
      autoplay: props.autoplay ? 1 : 0,
      modestbranding: 1,
      rel: 0,
    },
  };

  return (
    <ReactYoutube
      videoId={props.videoId}
      opts={opts}
      className={props.className}
      onReady={props.onReady}
      onPlay={props.onPlay}
      onPause={props.onPause}
      onEnd={props.onEnd}
      onError={props.onError}
      onStateChange={props.onStateChange}
      iframeClassName={props.iframeClassName}
    />
  );
}
